"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inject = void 0;

var displayStyle = function displayStyle(_ref) {
  var isInline = _ref.isInline;
  return "display: ".concat(isInline ? 'inline-' : '', "flex");
};

var width = function width(_ref2) {
  var isInline = _ref2.isInline;
  return "width: ".concat(isInline ? 'auto' : '100%');
};

var directionStyle = function directionStyle(_ref3) {
  var direction = _ref3.direction,
      isReversed = _ref3.isReversed;
  return "flex-direction: ".concat(direction).concat(isReversed ? '-reverse' : '');
};

var wrapStyle = function wrapStyle(_ref4) {
  var isWrap = _ref4.isWrap;
  return "flex-wrap: ".concat(isWrap ? 'wrap' : 'nowrap');
};

var inject = {
  displayStyle: displayStyle,
  width: width,
  directionStyle: directionStyle,
  wrapStyle: wrapStyle
};
exports.inject = inject;